import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import Grid from "@mui/material/Grid2";
import Loader from '../../layout/loading/loader';
import FeuillesTempsHebdoWeekTable from './FeuillesTempsHebdoWeekTable';

function FeuillesTempsHebdoTable({ feuillesTempsHebdo, loading, periodeId, operateurId }) {
    if (loading) {
        return <Loader />;
    }

    if (!feuillesTempsHebdo) {
        return (
            <Box>
                <Typography variant="h6">
                    Aucune donnée disponible
                </Typography>
            </Box>
        );
    }

    const { periode, operateur, semaines, totauxMensuels } = feuillesTempsHebdo;

    return (
        <Box>
            <Grid container spacing={2}>
                {/* Affichage des semaines */}
                {semaines.map((semaine, index) => (
                    <Grid item size={{ xs: 12 }} key={index}>
                        <FeuillesTempsHebdoWeekTable 
                            semaine={semaine} 
                            operateurId={operateur.id}
                            operateurLibelle={operateur.libelle}
                            periodeId={periodeId}
                        />
                    </Grid>
                ))}

                {/* Totaux mensuels */}
                <Grid item size={{ xs: 12 }}>
                    <Paper elevation={2} sx={{ p: 2, mt: 2 }}>
                        <Typography variant="h6" gutterBottom>
                            Totaux mensuels
                        </Typography>
                        <Grid container spacing={2}>
                            {/* Row 1: HN | HS combiné (centered, spans width of details) | Total */}
                            <Grid item size={{ xs: 3 }}>
                                <Typography variant="body1">
                                    <strong>Heures normales:</strong> {(totauxMensuels?.hn ?? 0).toFixed(2)}h
                                </Typography>
                            </Grid>
                            <Grid item size={{ xs: 6 }}>
                                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                                    <Typography variant="body1" align="center" sx={{ fontWeight: 600 }}>
                                        HS combiné: {(((totauxMensuels?.hsMinutes ?? 0) / 60)).toFixed(2)}h
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item size={{ xs: 3 }}>
                                <Typography variant="body1" align="right">
                                    <strong>Total:</strong> {(totauxMensuels?.total ?? 0).toFixed(2)}h
                                </Typography>
                            </Grid>

                            {/* Row 2: Empty | HS details (3 columns) | Empty */}
                            <Grid item size={{ xs: 3 }} />
                            <Grid item size={{ xs: 2 }}>
                                <Typography variant="body2" align="center">
                                    <strong>H25:</strong> {(totauxMensuels?.h25 ?? 0).toFixed(2)}h
                                </Typography>
                            </Grid>
                            <Grid item size={{ xs: 2 }}>
                                <Typography variant="body2" align="center">
                                    <strong>H50:</strong> {(totauxMensuels?.h50 ?? 0).toFixed(2)}h
                                </Typography>
                            </Grid>
                            <Grid item size={{ xs: 2 }}>
                                <Typography variant="body2" align="center">
                                    <strong>NUIT:</strong> {(totauxMensuels?.hnuit ?? 0).toFixed(2)}h
                                </Typography>
                            </Grid>
                            <Grid item size={{ xs: 3 }} />
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
}

export default FeuillesTempsHebdoTable;
